<p class="title h4">Modelli</p>
<div class="row" *ngIf="settings && settings.length">
  <div class="col-6">
    <p>Seleziona Setting:</p>
    <p class="example-section">
      <it-select id="default-select" [(ngModel)]="selectedSetting" defaultOption="Seleziona Setting"
        (ngModelChange)="onSelectedSetting()">
        <option [value]="null">Seleziona Setting</option>
        <option *ngFor="let setting of settings" [value]="setting.code">
          {{ setting.name }}
        </option>
      </it-select>
    </p>
  </div>
  <div class="col-7"></div>
</div>
<div class="row" *ngIf="forms && forms.length">
  <div class="col">
    <h5>Moduli disponibili:</h5>
  </div>
</div>
<div class="row" *ngIf="forms && forms.length">
  <div class="col">
    <div class="row mt-3" *ngFor="let form of forms">
      <div class="col-10">
        <h6> {{form.name}}</h6>
      </div>
      <div class="col-2">
        <button
            button itButton="outline-primary" type="button" (click)="print(form)"
          >
            Stampa modulo
          </button>
      </div>
    </div>
  </div>
</div>